<div class="mt-2">
    @if (!postponePending) {
        <button
            type="button"
            class="btn btn-primary"
            (click)="onPostponeSessionClicked()"
        >
            Postpone session
        </button>
    }

    @if (postponePending) {
        <div>
            <div class="input-group mb-3">
                <input
                    [(ngModel)]="numberOfDays"
                    #ctrl="ngModel"
                    type="text"
                    class="text-center form-control col-3"
                    placeholder="Number of days"
                    max="70"
                    min="0"
                    step="7"
                    type="number"
                />
                <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2">days</span>
                </div>
            </div>
            <button
                type="button"
                class="btn btn-primary mr-1 btn-action"
                (click)="onPostponeSessionClicked()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn btn-primary btn-action"
                (click)="postpone()"
            >
                Postpone
            </button>
        </div>
    }
</div>
